/* import __COLOCATED_TEMPLATE__ from './async-report-export-popover.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
var ExportStatus = /*#__PURE__*/function (ExportStatus) {
  ExportStatus["NOT_STARTED"] = "not_started";
  ExportStatus["IN_PROGRESS"] = "in_progress";
  ExportStatus["COMPLETE"] = "complete";
  return ExportStatus;
}(ExportStatus || {});
let AsyncReportExportPopover = (_class = class AsyncReportExportPopover extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "marketToasts", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "exportStatus", _descriptor3, this);
    _initializerDefineProperty(this, "activeToastId", _descriptor4, this);
    _initializerDefineProperty(this, "prevParamsVersion", _descriptor5, this);
  }
  get showLoader() {
    return this.exportStatus === ExportStatus.IN_PROGRESS;
  }
  get downloadReady() {
    return this.exportStatus === ExportStatus.COMPLETE;
  }
  async generateReport() {
    this.activeToastId = this.marketToasts.info(this.args.generatingReportModalText ?? this.intl.t('sharedUi.export.toast.generatingExport'), {
      persistent: true
    });
    this.exportStatus = ExportStatus.IN_PROGRESS;
    await this.args.generateReport().then(() => {
      const pollingTask = taskFor(this.pollForExportStatus);
      if (pollingTask.isRunning) {
        pollingTask.cancelAll();
      } else {
        pollingTask.perform();
      }
    });
  }
  *pollForExportStatus() {
    const shouldTimeout = Boolean(this.args.pollingTimeoutInMinutes);
    const startTime = shouldTimeout ? Date.now() : null;
    const timeoutMs = shouldTimeout ? this.args.pollingTimeoutInMinutes * 60 * 1000 : null;
    while (true) {
      const exportStatus = yield this.args.checkExportStatus();
      if (exportStatus) {
        this.exportStatus = ExportStatus.COMPLETE;
        this.marketToasts.success(this.args.reportReadyModalText ?? this.intl.t('sharedUi.export.toast.exportReady'), {
          action: this.args.downloadReport,
          actionText: this.intl.t('button.download')
        });
        this.marketToasts.remove(this.activeToastId);
        break;
      }

      // Check if we've exceeded the timeout (only if timeout is configured)
      if (shouldTimeout) {
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= timeoutMs) {
          this.exportStatus = ExportStatus.NOT_STARTED;
          this.marketToasts.warning(this.intl.t('sharedUi.export.toast.exportTimeout'));
          this.marketToasts.remove(this.activeToastId);
          break;
        }
      }
      yield timeout(this.args.pollingIntervalInSeconds * 1000);
    }
  }
  get triggerText() {
    return this.exportStatus === ExportStatus.COMPLETE ? this.intl.t('sharedUi.button.download') : this.intl.t('sharedUi.button.generate');
  }
  get description() {
    return this.exportStatus === ExportStatus.IN_PROGRESS ? this.intl.t('sharedUi.export.inProgress') : this.args.descriptionText;
  }
  get buttonRank() {
    return this.exportStatus === ExportStatus.COMPLETE ? 'primary' : 'secondary';
  }
  get disabled() {
    return this.args.disabled ?? false;
  }
  async onClickHandler() {
    if (this.exportStatus === ExportStatus.COMPLETE) {
      await this.args.downloadReport();
    } else {
      await this.generateReport();
    }
  }
  maybeReset(paramsVersion) {
    if (this.prevParamsVersion !== paramsVersion) {
      this.reset();
    }
  }
  reset() {
    this.exportStatus = ExportStatus.NOT_STARTED;
    this.activeToastId = null;
    this.prevParamsVersion = this.args.paramsVersion;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "exportStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ExportStatus.NOT_STARTED;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "activeToastId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "prevParamsVersion", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.paramsVersion;
  }
}), _applyDecoratedDescriptor(_class.prototype, "generateReport", [action], Object.getOwnPropertyDescriptor(_class.prototype, "generateReport"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pollForExportStatus", [task], Object.getOwnPropertyDescriptor(_class.prototype, "pollForExportStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickHandler", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maybeReset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "maybeReset"), _class.prototype), _class);
export { AsyncReportExportPopover as default };